import { useMemo } from 'react';

import { useTheme } from '@mui/material';

import type { ExtendedOptions } from '@/components/Chart/types/highcharts';
import { CHART_HEIGHT } from '@/features/DataHub/constants/charts';

const usePreviewOptions = (
  baseOptions: ExtendedOptions | undefined
): ExtendedOptions | undefined => {
  const fontColor = useTheme().palette.text.primary;

  return useMemo(() => {
    if (!baseOptions) return undefined;

    return {
      ...baseOptions,
      chart: {
        ...baseOptions.chart,
        height: CHART_HEIGHT
      },
      navigator: {
        enabled: false
      },
      rangeSelector: {
        enabled: false
      },
      legend: {
        enabled: true,
        itemStyle: {
          color: fontColor,
          fontSize: '0.8em',
          textOverflow: 'ellipsis'
        }
      },
      scrollbar: {
        enabled: false
      }
    };
  }, [baseOptions, fontColor]);
};

export default usePreviewOptions;
